/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Share_Get_ErrorInputs */



/**
* | output |
* | --- |
* | "Error getting shares. {message}" |
*
* @param {Team_Share_Get_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_get_error = /** @type {((inputs: Team_Share_Get_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Get_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de la récupération des partages. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Abrufen der Anteile. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante l'acquisizione delle condivisioni. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при получении акций. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al obtener acciones. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`获取份额时出错。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`共有の取得中にエラーが発生しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शेयर प्राप्त करने में त्रुटि। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao obter ações. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Error getting shares. ${i?.message}`)
});